


























import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

import MenuIcon from '@/assets/header/menu.svg';
import CloseIcon from 'mdi-vue/Close';
import HeaderUser from './HeaderUser.vue';
import HeaderNotification from './HeaderNotification.vue';

@Component({
  components: {
    MenuIcon,
    HeaderUser,
    CloseIcon,
    HeaderNotification,
  },
  computed: mapState(['sidebarCollapsed']),
})
export default class Header extends Vue {
  sidebarCollapsed!: boolean;
  $refs!: {
    header: HTMLDivElement;
  }

  stickied = false;
  observer!: IntersectionObserver;
  merchantName = '';
  isExternal = false;

  mounted() {
    this.observer = new IntersectionObserver(this.toggleSticky, {
      threshold: [0.6, 0.7, 0.8, 0.9, 1],
    });

    this.observer.observe(this.$refs.header);
    const user = JSON.parse(localStorage.getItem('USER') || '{}');
    const { merchant } = user.user;
    if (merchant !== null && merchant !== undefined) {
      this.isExternal = true;
      this.merchantName = merchant.merchant_name;
    }
  }

  unmount() {
    this.observer.unobserve(this.$refs.header);
  }

  toggleSticky([e]: IntersectionObserverEntry[]) {
    this.stickied = e.intersectionRatio < 0.8 && e.intersectionRatio > 0.2;
  }

  toggleSidebar() {
    this.$store.commit('toggleSidebar');
  }
}
